export const getItemPriceMultiplier = item => {
  const {
    resellerMultiplier,
    resellerInvoiceMultiplier
  } = item;
  if (Object.prototype.hasOwnProperty.call(item, 'resellerInvoiceMultiplier')) {
    return Number(resellerInvoiceMultiplier);
  }
  return Number(resellerMultiplier || 0);
};